export default __webpack_public_path__ + "static/media/bike.3d4a8b9e.svg";